import i18n from '../i18n';
import React, { useEffect, useState } from 'react';
import { withTranslation, useTranslation } from 'react-i18next';
import './Language.css';

const Language = (props) => {
    const { t } = props;
    const { i18n } = useTranslation();
    const [currentLang, setCurrentLang] = useState(i18n.language);
    useEffect(() => {
        i18n.changeLanguage(currentLang);
    }, [currentLang])
    const handleChange = e => {
        i18n.changeLanguage(e.target.value);
        setCurrentLang(e.target.value);
    };
    return (
        <label style={{ padding: "3px"}}>
            <select id="language" style={{backgroundColor:"transparent", border:"none", color: "white"}} value={currentLang} onChange={handleChange}>
                <option value="en-GB">🇺🇸&emsp;EN</option>
                <option value="pt-PT">🇵🇹&emsp;PT</option>
                <option value="es-ES">🇪🇸&emsp;ES</option>
            </select>
        </label>
        
    );
}
export default withTranslation()(Language);
